import { compare } from 'fast-json-patch';

export const initialState = {
  modalNovoGrupo: false,
  agrupamentos: []
};

export const mutations = {
  openModalGrupo(state, payload) {
    state.modalNovoGrupo = payload;
  },
  createGrupo(state, payload) {
    payload.id = state.agrupamentos.length + 1;
    const novaListaAgrupamentos = [ ...state.agrupamentos, payload ];
    state.agrupamentos = novaListaAgrupamentos;
  },
  updateGrupo(state, payload) {
    const { nome, vendedores, id } = payload;
    const novaListaAgrupamentos = state.agrupamentos
      .map(g => {
        if (g.id === id) {
          g.vendedores = vendedores;
          g.nome = nome;
        }
        return g;
      });

    state.agrupamentos = novaListaAgrupamentos;
  },
  deleteGrupo(state, payload) {
    const arrayAtualizado = state.agrupamentos.filter(g => {
      return g.id !== payload;
    });
    state.agrupamentos = arrayAtualizado;
  },
  setGrupos(state, payload) {
    if (payload.data) {
      const grupos = payload.data.map(g => {
        return {
          id: g._id,
          nome: g.clusterName,
          vendedores: g.clusterMembers
        };
      });
      state.agrupamentos = grupos;
      return;
    }
    state.agrupamentos = payload;
  }
};

export const actions = {
  async getGrupos(context) {
    const grupos = await R.Cluster.listarTodos();
    context.commit('setGrupos', grupos);
  },
  async patchGrupos(context, payload) {
    const { nome, vendedores, id } = payload;
    const currentCluester = await R.Cluster.listarUm(id);
    const { clusterMembers } = currentCluester.data;

    const patchOp = () => {
      return compare(
        { clusterMembers: clusterMembers.map(m => m.idVendedor) },
        { clusterMembers: vendedores.map(m => m.idVendedor) });
    };

    const parms = [{
      'op': 'replace',
      'path': 'clusterName',
      'value': nome
    }, ...patchOp()
    ];

    try {
      await R.Cluster.editarUmGrupo(parms, id);
      context.commit('updateGrupo', payload);
    } catch (error) {
      console.log(error);
    }
  },
  async excluirUmGrupo(context, payload) {
    await R.Cluster.excluirUm(payload);
    context.commit('deleteGrupo', payload);
  }
};

export const getters = {
};

export default {
  state: initialState,
  mutations: {
    ...mutations
  },
  getters: {
    ...getters
  },
  actions: {
    ...actions
  }
};
